import React from 'react';
import { Select, InputLabel, FormControl, FormHelperText, MenuItem } from "@mui/material";
import './SelectComponent.css';

function SelectComponent(props) {

    // Info
    const id = props.id;
    const input = props.handler.form[id];
    const label = input.label;

    const [error, setError] = React.useState(input.error);
    const [isFocus, setFocus] = React.useState(false);

    // Value
    const [value, setValue] = React.useState('');
    React.useEffect(() => {
        if (input.value !== undefined) {
            const nextValue = input.value.toString();
            setValue((previous) => (previous !== nextValue ? nextValue : previous));
        }
    }, [input.value]);
    React.useEffect(() => {
        setError((previous) => (previous !== input.error ? input.error : previous));
    }, [input.error]);

    // On
    const onChange = (event) => {
        let newValue = event.target.value ?? '';
        setValue(newValue);

        if (props.onChange) props.onChange(newValue);
    }
    const onBlur = () => {
        setFocus(false);
        props.handler.setValue(id, value);
        let error = props.handler.getErrorByField(input);
        setError(error);
        props.handler.setError(id, error);

        if (props.onBlur) props.onBlur(value);
    }
    const onFocus = () => {
        setFocus(true);
    }

    return (
        <div className="content-select">
            <FormControl variant="outlined"
                className={`select ${
                    isFocus && (!input.disabled && !props.disabled)
                        ? 'selectFocus'
                        : error && (!input.disabled && !props.disabled)
                            ? 'selectError'
                            : value && (!input.disabled && !props.disabled)
                                ? 'selectValid'
                                : ''
                }`}
            >
                <InputLabel
                    htmlFor="outlined"
                    style={value ? { transform: 'translate(15px, -4px) scale(0.75)' } : {}}
                >
                    {label + ((input.options && input.options.validation && input.options.validation.indexOf('required') > -1) ? ' *' : '')}
                </InputLabel>
                <Select
                    value={value}
                    defaultValue={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    label={label + ((input.options && input.options.validation && input.options.validation.indexOf('required') > -1) ? ' *' : '')}
                    inputProps={{ name: label + ((input.options && input.options.validation && input.options.validation.indexOf('required') > -1) ? ' *' : ''), id: props.name }}
                    disabled={input.disabled || props.disabled}
                    MenuProps={{
                        className: 'menu'
                    }}
                >
                    {
                        props.options.map((data, key) => {
                            return <MenuItem key={key} value={data.value}>{data.label}</MenuItem>;
                        })
                    }
                </Select>
                <FormHelperText>{error && !isFocus ? error : input.textHelper}</FormHelperText>
            </FormControl>
        </div>
    );
}

export default SelectComponent;
